// import AllCountries from 'babel-loader?presets[]=es2015!~/../node_modules/react-intl-tel-input/src/components/AllCountries.js'

function isNumeric (obj) {
  return obj - parseFloat(obj) >= 0
}

function getNumeric (s) {
  return s.replace(/\D/g, '')
}

// const countries = AllCountries.getCountries()
// let allCountryCodes = {}

// function addCountryCode (countryCodes, iso2, dialCode, priority) {
//   if (!(dialCode in countryCodes)) {
//     countryCodes[dialCode] = []
//   }

//   const index = priority || 0
//   countryCodes[dialCode][index] = iso2

//   return countryCodes
// }

// for (let i = 0; i < countries.length; i++) {
//   const c = countries[i]
//   addCountryCode(allCountryCodes, c.iso2, c.dialCode, c.priority);
//   // area codes
//   if (c.areaCodes) {
//     for (let j = 0; j < c.areaCodes.length; j++) {
//       // full dial code is country code + dial code
//       addCountryCode(allCountryCodes, c.iso2, c.dialCode + c.areaCodes[j]);
//     }
//   }
// }

// console.log(allCountryCodes)

const allCountryCodes = {
  '1': ['us', 'ca', 'do', 'pr'],
  '7': ['ru', 'kz'],
  '20': ['eg'],
  '27': ['za'],
  '30': ['gr'],
  '31': ['nl'],
  '32': ['be'],
  '33': ['fr'],
  '34': ['es'],
  '36': ['hu'],
  '39': ['it', 'va'],
  '40': ['ro'],
  '41': ['ch'],
  '43': ['at'],
  '44': ['gb', 'gg', 'im', 'je'],
  '45': ['dk'],
  '46': ['se'],
  '47': ['no', 'sj'],
  '48': ['pl'],
  '49': ['de'],
  '51': ['pe'],
  '52': ['mx'],
  '53': ['cu'],
  '54': ['ar'],
  '55': ['br'],
  '56': ['cl'],
  '57': ['co'],
  '58': ['ve'],
  '60': ['my'],
  '61': ['au', 'cc', 'cx'],
  '62': ['id'],
  '63': ['ph'],
  '64': ['nz'],
  '65': ['sg'],
  '66': ['th'],
  '81': ['jp'],
  '82': ['kr'],
  '84': ['vn'],
  '86': ['cn'],
  '90': ['tr'],
  '91': ['in'],
  '92': ['pk'],
  '93': ['af'],
  '94': ['lk'],
  '95': ['mm'],
  '98': ['ir'],
  '211': ['ss'],
  '212': ['ma', 'eh'],
  '213': ['dz'],
  '216': ['tn'],
  '218': ['ly'],
  '220': ['gm'],
  '221': ['sn'],
  '222': ['mr'],
  '223': ['ml'],
  '224': ['gn'],
  '225': ['ci'],
  '226': ['bf'],
  '227': ['ne'],
  '228': ['tg'],
  '229': ['bj'],
  '230': ['mu'],
  '231': ['lr'],
  '232': ['sl'],
  '233': ['gh'],
  '234': ['ng'],
  '235': ['td'],
  '236': ['cf'],
  '237': ['cm'],
  '238': ['cv'],
  '239': ['st'],
  '240': ['gq'],
  '241': ['ga'],
  '242': ['cg'],
  '243': ['cd'],
  '244': ['ao'],
  '245': ['gw'],
  '246': ['io'],
  '248': ['sc'],
  '249': ['sd'],
  '250': ['rw'],
  '251': ['et'],
  '252': ['so'],
  '253': ['dj'],
  '254': ['ke'],
  '255': ['tz'],
  '256': ['ug'],
  '257': ['bi'],
  '258': ['mz'],
  '260': ['zm'],
  '261': ['mg'],
  '262': ['re', 'yt'],
  '263': ['zw'],
  '264': ['na'],
  '265': ['mw'],
  '266': ['ls'],
  '267': ['bw'],
  '268': ['sz'],
  '269': ['km'],
  '290': ['sh'],
  '291': ['er'],
  '297': ['aw'],
  '298': ['fo'],
  '299': ['gl'],
  '350': ['gi'],
  '351': ['pt'],
  '352': ['lu'],
  '353': ['ie'],
  '354': ['is'],
  '355': ['al'],
  '356': ['mt'],
  '357': ['cy'],
  '358': ['fi', 'ax'],
  '359': ['bg'],
  '370': ['lt'],
  '371': ['lv'],
  '372': ['ee'],
  '373': ['md'],
  '374': ['am'],
  '375': ['by'],
  '376': ['ad'],
  '377': ['mc'],
  '378': ['sm'],
  '380': ['ua'],
  '381': ['rs'],
  '382': ['me'],
  '383': ['xk'],
  '385': ['hr'],
  '386': ['si'],
  '387': ['ba'],
  '389': ['mk'],
  '420': ['cz'],
  '421': ['sk'],
  '423': ['li'],
  '500': ['fk'],
  '501': ['bz'],
  '502': ['gt'],
  '503': ['sv'],
  '504': ['hn'],
  '505': ['ni'],
  '506': ['cr'],
  '507': ['pa'],
  '508': ['pm'],
  '509': ['ht'],
  '590': ['gp', 'bl', 'mf'],
  '591': ['bo'],
  '592': ['gy'],
  '593': ['ec'],
  '594': ['gf'],
  '595': ['py'],
  '596': ['mq'],
  '597': ['sr'],
  '598': ['uy'],
  '599': ['cw', 'bq'],
  '670': ['tl'],
  '672': ['nf'],
  '673': ['bn'],
  '674': ['nr'],
  '675': ['pg'],
  '676': ['to'],
  '677': ['sb'],
  '678': ['vu'],
  '679': ['fj'],
  '680': ['pw'],
  '681': ['wf'],
  '682': ['ck'],
  '683': ['nu'],
  '685': ['ws'],
  '686': ['ki'],
  '687': ['nc'],
  '688': ['tv'],
  '689': ['pf'],
  '690': ['tk'],
  '691': ['fm'],
  '692': ['mh'],
  '850': ['kp'],
  '852': ['hk'],
  '853': ['mo'],
  '855': ['kh'],
  '856': ['la'],
  '880': ['bd'],
  '886': ['tw'],
  '960': ['mv'],
  '961': ['lb'],
  '962': ['jo'],
  '963': ['sy'],
  '964': ['iq'],
  '965': ['kw'],
  '966': ['sa'],
  '967': ['ye'],
  '968': ['om'],
  '970': ['ps'],
  '971': ['ae'],
  '972': ['il'],
  '973': ['bh'],
  '974': ['qa'],
  '975': ['bt'],
  '976': ['mn'],
  '977': ['np'],
  '992': ['tj'],
  '993': ['tm'],
  '994': ['az'],
  '995': ['ge'],
  '996': ['kg'],
  '998': ['uz'],
  '1204': ['ca'],
  '1226': ['ca'],
  '1236': ['ca'],
  '1242': ['bs'],
  '1246': ['bb'],
  '1249': ['ca'],
  '1250': ['ca'],
  '1264': ['ai'],
  '1268': ['ag'],
  '1284': ['vg'],
  '1289': ['ca'],
  '1306': ['ca'],
  '1340': ['vi'],
  '1343': ['ca'],
  '1345': ['ky'],
  '1365': ['ca'],
  '1387': ['ca'],
  '1403': ['ca'],
  '1416': ['ca'],
  '1418': ['ca'],
  '1431': ['ca'],
  '1437': ['ca'],
  '1438': ['ca'],
  '1441': ['bm'],
  '1450': ['ca'],
  '1473': ['gd'],
  '1506': ['ca'],
  '1514': ['ca'],
  '1519': ['ca'],
  '1548': ['ca'],
  '1579': ['ca'],
  '1581': ['ca'],
  '1587': ['ca'],
  '1604': ['ca'],
  '1613': ['ca'],
  '1639': ['ca'],
  '1647': ['ca'],
  '1649': ['tc'],
  '1664': ['ms'],
  '1670': ['mp'],
  '1671': ['gu'],
  '1672': ['ca'],
  '1684': ['as'],
  '1705': ['ca'],
  '1709': ['ca'],
  '1721': ['sx'],
  '1742': ['ca'],
  '1758': ['lc'],
  '1767': ['dm'],
  '1778': ['ca'],
  '1780': ['ca'],
  '1782': ['ca'],
  '1784': ['vc'],
  '1787': ['pr'],
  '1807': ['ca'],
  '1809': ['do'],
  '1819': ['ca'],
  '1825': ['ca'],
  '1829': ['do'],
  '1849': ['do'],
  '1867': ['ca'],
  '1868': ['tt'],
  '1869': ['kn'],
  '1873': ['ca'],
  '1876': ['jm'],
  '1902': ['ca'],
  '1905': ['ca'],
  '1939': ['pr']
}

export default function countryCodeForPhone (number) {
  let dialCode = ''
  // only interested in international numbers (starting with a plus)
  if (number.charAt(0) === '+') {
    let numericChars = ''
    // iterate over chars
    for (let i = 0, max = number.length; i < max; i++) {
      const c = number.charAt(i)
      // if char is number
      if (isNumeric(c)) {
        numericChars += c
        // if current numericChars make a valid dial code
        if (allCountryCodes[numericChars]) {
          // store the actual raw string (useful for matching later)
          dialCode = number.substr(0, i + 1)
        }
        // longest dial code is 4 chars
        if (numericChars.length === 4) {
          break
        }
      }
    }
  }

  if (dialCode) {
    // check if one of the matching countries is already selected
    const countryCodes = allCountryCodes[getNumeric(dialCode)]
    let countryCode

    // if using onlyCountries option, countryCodes[0] may be empty,
    // so we must find the first non-empty index
    for (let j = 0; j < countryCodes.length; j++) {
      if (countryCodes[j]) {
        countryCode = countryCodes[j]
        break
      }
    }

    return countryCode
  }
}
